// extracted by mini-css-extract-plugin
export default {"message-container":"Message_message-container__NiVma","message":"Message_message__cJFfN","date":"Message_date__zv+g5"};